import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   RADEAU — une PLATEFORME VOLANTE. Un porteur MOBILE, pas un rocher.

   C'est le complexe militaire qui se met à voler : un socle large et INDESTRUCTIBLE
   qui ONDULE latéralement en descendant (`drift.sway`), et qui EMPORTE ses canons.
   Les sentinelles montées dessus le CHEVAUCHENT (`ride: true` dans le placement) :
   elles le suivent où qu'il aille, et partent avec lui à sa sortie. On ne peut pas
   l'abattre — on démonte ses tourelles, ou on l'esquive pendant qu'il louvoie.

   `radius: 66` : large, entre le caisson (60) et le Colosse (82). Assez pour porter
   deux tourelles et se lire comme une plateforme, assez étroit pour laisser un
   couloir de chaque côté même au bout de son ondulation.

   `sway` ±100 sur 5,5 s : il traverse lentement, prévisiblement. La menace est ses
   canons et son louvoiement, jamais un mouvement brusque — le joueur doit pouvoir
   anticiper où sera la plateforme dans une seconde (même règle que le pilotage du
   Héraut).
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'radeau',
  radius: 66,
  hp: 1,
  destructible: false,
  drift: { swayAmp: 100, swayPeriod: 5.5 },
  // Rendu comme une DALLE plate (pas un rocher) : c'est une structure, pas de la
  // roche. La sim reste un disque de rayon 66.
  platform: true,
});
